// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3oXI-","content":"styles_content__21X6f","selectAll":"styles_selectAll__1o33i"};